import { useContext } from 'react';
import { NpsContext } from './context';

export function useNps() {
  return useContext(NpsContext);
}
